import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { FeatureFlagsRoute } from '../../routing'

export  class FeatureFlagsPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <FeatureFlagsRoute />
          </Fragment>
        )
    }
}
